export default __webpack_public_path__ + "static/media/get-started.3d78b8c4.png";